/**
 * Mock 动态配置数据
 * 用于开发调试阶段，无远程配置接口时的功能测试和验证
 */

import type { DynamicConfig } from '../types/dynamic-config'

/**
 * Mock 动态配置
 * 包含 3 个示例页面，涵盖 click、expose、custom 事件类型
 */
export const MOCK_DYNAMIC_CONFIG: DynamicConfig = {
  appStatus: 1,
  globalSamplingRate: 100,
  versionNo: '1.0.0',
  hasNewVersion: false,
  pages: {
    // // 首页
    // '/': {
    //   pageId: '/',
    //   businessName: '首页',
    //   eles: {
    //     'nav-search': {
    //       eleName: '搜索按钮',
    //       eleId: 'nav-search',
    //       eleBusinessName: '搜索按钮',
    //       events: [
    //         {
    //           eventType: 'click',
    //           eventCode: 'nav_search_click',
    //           eventName: 'nav_search_click',
    //           fields: [],
    //         },
    //       ],
    //     },
    //     'hero-banner': {
    //       eleName: '首页横幅',
    //       eleId: 'hero-banner',
    //       eleBusinessName: '首页横幅',
    //       events: [
    //         {
    //           eventType: 'expose',
    //           eventCode: 'hero_banner_expose',
    //           eventName: 'hero_banner_expose',
    //           fields: [],
    //         },
    //         {
    //           eventType: 'click',
    //           eventCode: 'hero_banner_click',
    //           eventName: 'hero_banner_click',
    //           fields: [],
    //         },
    //       ],
    //     },
    //     'recommend-list': {
    //       eleName: '推荐列表',
    //       eleId: 'recommend-list',
    //       eleBusinessName: '推荐列表',
    //       events: [
    //         {
    //           eventType: 'expose',
    //           eventCode: 'recommend_list_expose',
    //           eventName: 'recommend_list_expose',
    //           fields: [],
    //         },
    //       ],
    //     },
    //   },
    // },

    // // 商品详情页（带动态路由参数）
    // '/product/:id': {
    //   pageId: '/product/:id',
    //   businessName: '商品详情页',
    //   eles: {
    //     'product-image': {
    //       eleName: '商品图片',
    //       eleId: 'product-image',
    //       eleBusinessName: '商品图片',
    //       events: [
    //         {
    //           eventType: 'expose',
    //           eventCode: 'product_image_expose',
    //           eventName: 'product_image_expose',
    //           fields: [],
    //         },
    //       ],
    //     },
    //     'add-to-cart': {
    //       eleName: '加入购物车',
    //       eleId: 'add-to-cart',
    //       eleBusinessName: '加入购物车',
    //       events: [
    //         {
    //           eventType: 'click',
    //           eventCode: 'add_to_cart_click',
    //           eventName: 'add_to_cart_click',
    //           fields: [
    //             { fieldKey: 'productId', fieldSource: 'manual' },
    //             { fieldKey: 'productName', fieldSource: 'manual' },
    //             { fieldKey: 'price', fieldSource: 'manual' },
    //           ],
    //         },
    //       ],
    //     },
    //     'buy-now': {
    //       eleName: '立即购买',
    //       eleId: 'buy-now',
    //       eleBusinessName: '立即购买',
    //       events: [
    //         {
    //           eventType: 'click',
    //           eventCode: 'buy_now_click',
    //           eventName: 'buy_now_click',
    //           fields: [
    //             { fieldKey: 'productId', fieldSource: 'manual' },
    //             { fieldKey: 'userId', fieldSource: 'manual' },
    //           ],
    //         },
    //       ],
    //     },
    //   },
    // },

    // // 购物车页面
    // '/user/learning-center/xuetiku/custom': {
    //   pageId: '/user/learning-center/xuetiku/custom',
    //   businessName: '购物车页面',
    //   eles: {
    //     'el-count': {
    //       eleName: '剩余组卷次数',
    //       eleId: 'el-count',
    //       eleBusinessName: '剩余组卷次数',
    //       events: [
    //         // {
    //         //   eventType: 'expose',
    //         //   eventName: 'cart_item_expose',
    //         //   fields: [
    //         //     { key: 'productId', source: 'row' },
    //         //   ],
    //         // },
    //         {
    //           eventType: 'click',
    //           eventCode: 'click_remaining_times',
    //           eventName: '点击-剩余组卷次数',
    //           fields: [
    //             { fieldKey: 'productId', fieldSource: 'manual' },
    //             { fieldKey: 'quantity', fieldSource: 'manual' },
    //           ],
    //         },
    //         {
    //           eventType: 'expose',
    //           eventCode: 'expose_remaining_times',
    //           eventName: '曝光-剩余组卷次数',
    //           fields: [
    //             { fieldKey: 'productId', fieldSource: 'manual' },
    //             { fieldKey: 'quantity', fieldSource: 'manual' },
    //           ],
    //         }
    //       ],
    //     },
    //     'checkout-btn': {
    //       eleName: '结算按钮',
    //       eleId: 'checkout-btn',
    //       eleBusinessName: '结算按钮',
    //       events: [
    //         {
    //           eventType: 'click',
    //           eventCode: 'checkout_click',
    //           eventName: 'checkout_click',
    //           fields: [
    //             { fieldKey: 'totalAmount', fieldSource: 'manual' },
    //             { fieldKey: 'itemCount', fieldSource: 'manual' },
    //           ],
    //         },
    //       ],
    //     },
    //     'clear-cart': {
    //       eleName: '清空购物车',
    //       eleId: 'clear-cart',
    //       eleBusinessName: '清空购物车',
    //       events: [
    //         {
    //           eventType: 'click',
    //           eventCode: 'clear_cart_click',
    //           eventName: 'clear_cart_click',
    //           fields: [],
    //         },
    //       ],
    //     },
    //   },
    // },
  },
}
